import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useLinkComponent } from "../BraidProvider/BraidProvider.mjs";
import { buildDataAttributes } from "../private/buildDataAttributes.mjs";
import { ButtonContainer, useButtonStyles, ButtonOverlays, ButtonText } from "../Button/Button.mjs";
import { Box } from "../Box/Box.mjs";
const ButtonLink = forwardRef(
  ({
    children,
    size,
    tone,
    variant,
    bleed,
    icon,
    iconPosition,
    loading,
    data,
    ...restProps
  }, ref) => {
    const LinkComponent = useLinkComponent(ref);
    return /* @__PURE__ */ jsx(ButtonContainer, { bleed, variant, children: /* @__PURE__ */ jsxs(
      Box,
      {
        component: LinkComponent,
        ref,
        ...restProps,
        ...buildDataAttributes({ data, validateRestProps: false }),
        ...useButtonStyles({
          variant,
          tone,
          size,
          bleed,
          loading
        }),
        children: [
          /* @__PURE__ */ jsx(ButtonOverlays, { variant, tone }),
          /* @__PURE__ */ jsx(
            ButtonText,
            {
              variant,
              tone,
              size,
              loading,
              icon,
              iconPosition,
              bleed,
              children
            }
          )
        ]
      }
    ) });
  }
);
ButtonLink.displayName = "ButtonLink";
export {
  ButtonLink
};
